module.exports = __webpack_public_path__ + "img/fd_title.c5148437.png";